import { FC, useCallback, useEffect } from 'react';

import { FullScreenLoader } from 'components/common';
import OnboardingFormWrapper from 'components/common/OnBoardingFormWrapper';
import { useGoogleAnalytics } from 'hooks/useGoogleAnalytics/useGoogleAnalytics';
import { OnboardingPageWrapper } from '../../components/common/OnboardingPageWrapper/OnboardingPageWrapper';
import { LOGIN_TO_MANTA_CARE_ACCOUNT, WELCOME_BACK, WELCOME_BACK_TO_YOUR_JOURNEY } from '../../constants/onboarding';
import { useLoginFlow } from '../../hooks/useLoginFlow/useLoginFlow';
import { LoginPageWrapper } from './Login.styled';
import { LoginForm } from './LoginForm';

export const Login: FC = () => {
    const { loading, login, error, verifyingSession, verifySession, clearError } = useLoginFlow();
    const { sendPageViews } = useGoogleAnalytics();

    useEffect(() => {
        sendPageViews();
        verifySession();
    }, []);

    const submitHandler = useCallback(
        (email: string, password: string) => {
            login(email, password);
        },
        [login]
    );

    return (
        <OnboardingPageWrapper showTopLeftVector showBottomLeftVector>
            <FullScreenLoader loading={verifyingSession} />
            <LoginPageWrapper>
                <OnboardingFormWrapper
                    header={WELCOME_BACK_TO_YOUR_JOURNEY}
                    blueHeader={WELCOME_BACK}
                    mediumHeader={LOGIN_TO_MANTA_CARE_ACCOUNT}
                    headerWidth="61rem"
                >
                    <LoginForm onSubmit={submitHandler} loading={loading} error={error} clearError={clearError} />
                </OnboardingFormWrapper>
            </LoginPageWrapper>
        </OnboardingPageWrapper>
    );
};
